import { useEffect } from 'react';
import { useAuthentication } from './authentication-hook';

export function AuthenticationGuard({ children }) {
    const {
        login,
        isAuthenticated,
    } = useAuthentication();

    useEffect(() => {
        if (!isAuthenticated) {
            login({
                redirectUri: window.location.href,
            });
        }
    }, [ isAuthenticated ]);

    if (isAuthenticated) {
        return children;
    }

    return null;
}
